<template>
	<div class="layout layout--small portable-ph-">
		<div class="layout__item u-1/1-palm u-1/2 mb-">
			<h4 class="c-filter-section__sub-heading mb--">
				<label for="costDisplaySelect">Toon kosten</label>
			</h4>
			<div class="o-select">
				<select id="costDisplaySelect" class="palm-pv-" v-model="costDisplay" @change="updateParent">
					<option v-for="cost in costDisplayOptions" :key="cost.Value" :value="cost.Value">
						{{ cost.Text }}
					</option>
				</select>
				<div class="o-select__arrow">
					<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 7H0l4 5 4-5zm0-2H0l4-5 4 5z" fill="#3D3D3D" fill-rule="evenodd" />
					</svg>
				</div>
			</div>
		</div>
		<div class="layout__item u-1/1-palm u-1/2 mb-">
			<h4 class="c-filter-section__sub-heading mb--">
				<label for="sortSelect">Sorteer op</label>
			</h4>
			<div class="o-select">
				<select id="sortSelect" class="palm-pv-" v-model="sortOption" @change="updateParent">
					<option v-for="sortOption in sortOptions" :key="sortOption.Value" :value="sortOption.Value">
						{{ sortOption.Text }}
					</option>
				</select>
				<div class="o-select__arrow">
					<svg width="8" height="12" viewBox="0 0 8 12" xmlns="http://www.w3.org/2000/svg">
						<path d="M8 7H0l4 5 4-5zm0-2H0l4-5 4 5z" fill="#3D3D3D" fill-rule="evenodd" />
					</svg>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		sortOptions: {
			type: Array,
			default: () => [],
		},
		costDisplayOptions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			sortOption: 'TotalExpenses',
			costDisplay: 'PerMaand',
			initiallySet: false,
		};
	},
	updated() {
		if (!this.initiallySet) {
			this.sortOption = this.sortOptions.find((sO) => sO.IsSelected).Value;
			this.costDisplay = this.costDisplayOptions.find((cD) => cD.IsSelected).Value;
			this.initiallySet = true;
		}
	},
	watch: {},
	methods: {
		updateParent() {
			// Prevents the observer to be passed
			const cleanData = Object.assign({}, this.$data);
			this.$emit('valuechanged', cleanData);
		},
	},
};
</script>

<style lang="scss"></style>
